module.exports = __webpack_public_path__ + "img/pollentia-logo.a90332b4.png";